// CreatedPublishInformationTab.js
import React from "react";
import { getOrDash, formatDateTime } from "../../Uitls/DetailsHelpers";
import Row from "./DetailsRow";

function CreatedPublishInformationTab({ bannerDetails = {} }) {
  return (
    <div className="tab-pane-wrap">
      <Row
        label="Created By:"
        value={getOrDash(bannerDetails?.createdByEmail)}
      />
      <Row
        label="Created On:"
        value={formatDateTime(bannerDetails?.createdDateTime)}
      />
      <Row
        label="Last Modified By:"
        value={getOrDash(bannerDetails?.updatedByEmail)}
      />
      <Row
        label="Last Modified On:"
        value={formatDateTime(bannerDetails?.updatedDateTime)}
      />
      <Row
        label="Published By:"
        value={getOrDash(bannerDetails?.publishedBy)}
      />
      <Row
        label="Published On:"
        value={formatDateTime(bannerDetails?.publishedOn)}
      />
    </div>
  );
}

export default CreatedPublishInformationTab;
